export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const FETCH_USERS_LIST = 'FETCH_USERS_LIST';
export const GET_SINGLE_USER = 'GET_SINGLE_USER';
export const SET_USERS_PARAMS = 'SET_USERS_PARAMS';

export const CLEAR_USERS_PARAMS = 'CLEAR_USERS_PARAMS';
export const CLEAR_USERS_STORE = 'CLEAR_USERS_STORE';
export const CLEAR_SINGLE_USER_STORE = 'CLEAR_SINGLE_USER_STORE';
